import React from 'react';
import {useParams} from "react-router";
import {useQuery} from "react-query";
import {ReservationDTO} from "../../reservation/types";
import axios from "axios";
import {LoadingOverlay} from "../common/loading/component";
import {ReservationCard} from "./ReservationCard";
import {EnsureLoggedIn} from "../../admin/EnsureLoggedIn";
import {LauncherLayout} from "../layout/LauncherLayout";
import {useAuthContext} from "../auth/LauncherAuthContext";

export const ReservationOverview = () => {
    const { reservationId } = useParams();
    const {user} = useAuthContext();
    const {data: reservation, isLoading, refetch} = useQuery<ReservationDTO>({
        queryKey: ['reservation-overview', user?.id, reservationId],
        queryFn: async () => {
            const response = await axios.get(`/api/launcher/my/reservations/${reservationId}`);
            return response.data;
        }
    });
    return (
        <LauncherLayout>
            <EnsureLoggedIn>

                <LoadingOverlay working={isLoading} />
                {reservation && (
                    <ReservationCard rsv={reservation} reload={refetch} />
                )}
            </EnsureLoggedIn>
        </LauncherLayout>
    );
}